import { Auth, getCookie } from '../lib/cookie'

export class AdminGuard {
  static isSigned() {
    return getCookie(Auth.AccessToken)
  }

  /**
   * Admin route guard handler
   * @param {import('vue-router').Route} from
   * @param {import('vue-router').Route} to
   * @param {import('vue-router').NavigationGuardNext} next
   * @returns {Boolean}
   */
  static watch(_, __, next) {
    if (AdminGuard.isSigned()) {
      next()
    } else {
      next('/admins/logins')
    }
  }
}
